export const quotationsTranslations = {
  ar: {
    title: 'عروض الأسعار',
    addNew: 'عرض سعر جديد',
    loading: 'جاري تحميل عروض الأسعار...',
    error: 'فشل تحميل عروض الأسعار',
    noQuotations: 'لا توجد عروض أسعار',

    // Filters & selectors
    selectBranch: 'اختر الفرع',
    selectCustomer: 'اختر العميل',

    // Status
    status: 'الحالة',
    statusDraft: 'مسودة',
    statusApproved: 'معتمد',
    statusCancelled: 'ملغي',
    statusConverted: 'محول',
    cannotEditConverted: 'لا يمكن تعديل عرض السعر المحول',
    alreadyConverted: 'تم تحويل هذا العرض مسبقاً',

    // Totals / aggregations
    totalAmount: 'إجمالي المبلغ',
    totalTax: 'إجمالي الضريبة',
    totalDiscount: 'إجمالي الخصم',
    total: 'الإجمالي',
    additions: 'الإضافات',

    // Conversion
    convertToInvoice: 'تحويل إلى فاتورة بيع',
    convertSuccess: 'تم تحويل عرض السعر إلى فاتورة بيع بنجاح',
    convertError: 'فشل تحويل عرض السعر إلى فاتورة بيع',

    // Misc
    deleteSuccess: 'تم حذف عرض السعر بنجاح',
    deleteError: 'فشل حذف عرض السعر',
  },
  en: {
    title: 'Quotations',
    addNew: 'New Quotation',
    loading: 'Loading quotations...',
    error: 'Failed to load quotations',
    noQuotations: 'No quotations',

    // Filters & selectors
    selectBranch: 'Select Branch',
    selectCustomer: 'Select Customer',

    // Status
    status: 'Status',
    statusDraft: 'Draft',
    statusApproved: 'Approved',
    statusCancelled: 'Cancelled',
    statusConverted: 'Converted',
    cannotEditConverted: 'Cannot edit a converted quotation',
    alreadyConverted: 'This quotation has already been converted',

    // Totals / aggregations
    totalAmount: 'Total Amount',
    totalTax: 'Total Tax',
    totalDiscount: 'Total Discount',
    total: 'Total',
    additions: 'Additions',

    // Conversion
    convertToInvoice: 'Convert to Sales Invoice',
    convertSuccess: 'Quotation converted to invoice successfully',
    convertError: 'Failed to convert quotation to invoice',

    // Misc
    deleteSuccess: 'Quotation deleted successfully',
    deleteError: 'Failed to delete quotation',
  },
  fr: {
    title: 'Devis',
    addNew: 'Nouveau devis',
    loading: 'Chargement des devis...',
    error: 'Échec du chargement des devis',
    noQuotations: 'Aucun devis',

    // Filters & selectors
    selectBranch: 'Sélectionner la succursale',
    selectCustomer: 'Sélectionner le client',

    // Status
    status: 'Statut',
    statusDraft: 'Brouillon',
    statusApproved: 'Approuvé',
    statusCancelled: 'Annulé',
    statusConverted: 'Converti',
    cannotEditConverted: 'Impossible de modifier un devis converti',
    alreadyConverted: 'Ce devis a déjà été converti',

    // Totals / aggregations
    totalAmount: 'Montant total',
    totalTax: 'Total TVA',
    totalDiscount: 'Remise totale',
    total: 'Total',
    additions: 'Suppléments',

    // Conversion
    convertToInvoice: 'Convertir en facture de vente',
    convertSuccess: 'Devis converti en facture avec succès',
    convertError: 'Échec de la conversion du devis en facture',

    // Misc
    deleteSuccess: 'Devis supprimé avec succès',
    deleteError: 'Échec de la suppression du devis',
  },
}


